<div class="row bg-light" >

  @if (withMenu) {
    <div class="{{classMenu}}"  id="menu" style="height: 100%;">
      <app-menu></app-menu>
    </div>
  }
  @if (withMenu) {
    <div class="col-md-9 col-lg-10" id="content" style="height: 100%;">
      <div class="row mt-2" >
        <div class="{{classContent}} mt-4"  >
          <router-outlet></router-outlet>
        </div>
        <div class="{{classProfile}}" >
          <div class="row justify-content-end">
            <div class="justify-content-end nav-item dropdown d-flex justify-content-end align-items-end mr-3">
              <div class="nav-link dropdown-toggle"  id="profilDropDown" role="button" data-bs-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false"><span class="fs-4 text-success">
              {{sessionInfo.partner.name}} </span>
            </div>
            <div class="dropdown-menu" aria-labelledby="profilDropDown">
              <div  class="dropdown-item" ><span class="fs-4 "> {{sessionInfo.firstName}} {{sessionInfo.lastName}}</span></div>
              <div  class="dropdown-item" >{{sessionInfo.role.libelle}}</div>
              <div  class="dropdown-item" >{{sessionInfo.username}}</div>
              <div class="dropdown-divider"></div>
              <div  class="dropdown-item text-danger" (click)="onDeconnect()">Déconnexion</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (!withMenu) {
  <div class="col-md-12 mt-2">
    <router-outlet></router-outlet>
  </div>
}
</div>
